import { AsyncPipe, CommonModule, NgClass, NgTemplateOutlet } from '@angular/common'
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatTooltip } from '@angular/material/tooltip'
import { PcIconComponent } from '@shared/components/pc-icon/pc-icon.component'
import { BehaviorSubject } from 'rxjs'
import { CustomMatSpinnerDirective } from '../../../directives/custom-mat-spinner.directive'
import { HoverAnimation, VerifyAnimation } from './pc-button.animation'

@Component({
  selector: 'pc-button',
  templateUrl: './pc-button.component.html',
  styleUrls: ['./pc-button.component.scss'],
  animations: [HoverAnimation, VerifyAnimation],
  imports: [MatButton, NgClass, MatTooltip, MatProgressSpinner, CustomMatSpinnerDirective, NgTemplateOutlet, AsyncPipe, PcIconComponent, CommonModule],
})
export class PCButtonComponent {
  @ViewChild('innerButton') innerButton: ElementRef<MatButton>

  // I would like to use the click event emitter, but it is not possible to overwrite them yet (angular 15)
  @Output() btnClick = new EventEmitter()
  @Input() text = ''
  @Input() size: 'small' | 'regular' | 'large' | 'narrow' | 'minimal' = 'regular'
  @Input() wide = false
  @Input() variant: 'primary' | 'secondary' | 'deletion' = 'primary'
  @Input() disabled = false
  @Input() active = true
  @Input() verifiable = false
  @Input() inputID: string
  @Input() analyticsID: string
  @Input() minimalSize: boolean
  @Input() tooltip: string
  @Input() matStepperNext: boolean

  buttonWidth: string

  // We need to make sure, that the initial button doesn't get smaller if the loading animation starts
  // Also we can use this to trigger a success animation once the uploading is done
  private loadingHasBeenTrue: boolean = false

  @Input()
  set isLoading(loading: boolean) {
    if (loading) {
      this._isLoading = loading
      this.loadingHasBeenTrue = true
      // @ts-ignore
      this.buttonWidth = this.innerButton?._elementRef?.nativeElement?.offsetWidth + 'px'
    } else {
      setTimeout(() => {
        this._isLoading = false
      }, 500)

      // watch out, it could happen that the animation is visible initially if this button is inside a modal which gets closed too fast.
      // Before closing your modal wait for the animation to finish (1500ms)
      if (this.loadingHasBeenTrue) {
        this.success$.next(true)
        setTimeout(() => {
          this.success$.next(false)
        }, 1500)
      }
    }
  }

  get isLoading(): boolean {
    return this._isLoading
  }
  private _isLoading = false

  // Icon only mode hides the text but shows an icon
  @Input() iconOnly = false

  @Input() icon: string = 'info'

  @Input() noUppercase: boolean

  @Input() success$: BehaviorSubject<boolean> = new BehaviorSubject(false)

  hover = false

  verificationVisible = false

  buttonClicked(event: MouseEvent) {
    if (this.verifiable) {
      this.btnClick.emit(event)
      this.verificationVisible = true
      setTimeout(() => {
        this.verificationVisible = false
      }, 2000)
    } else {
      this.btnClick.emit(event)
    }
  }

  // changes the hove state on mouseenter and mouseleave in order to control animations
  hoverChanged(event: MouseEvent) {
    if (event.type === 'mouseenter') {
      this.hover = true
    } else if (event.type === 'mouseleave') {
      this.hover = false
    }
  }
}
